import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import toJS from "../../../helpers/toJS";
import { Row, Col } from "react-flexbox-grid";
import Logo from "../../images/Logo";
import CustomInput from "../../common/customInput";
import Button from "../../common/button";
import TwitterIcon from "../../images/TwitIcon";
import FacebookIcon from "../../images/FacebookIcon";
import InstaIcon from "../../images/InstaIcon";
import PinIcon from "../../images/PinIcon";
import VimeoIcon from "../../images/VimeoIcon";
import { withRouter } from "react-router";
import Helmet from "react-helmet";
import axios from "axios";
import { baseUrl } from "../../../helpers/api";
import { showToastMessage } from "../../../actions";
import logo from "../../images/logo.png"

const Footer = (props) => {
  if (props.location.pathname.includes("/print")) {
    return null;
  } else {
    const [state, setState] = useState({
      email: "",
      isSubmitting: false,
    });
    const addMemberToMailchimp = (e) => {
      e.preventDefault();
      if (/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(state.email)) {
        setState({ ...state, isSubmitting: true });
        axios({
          method: "POST",
          url: `${baseUrl}/api/v1/add-to-mailchimp`,
          data: {
            email: state.email,
            type: "newsletter",
          },
        })
          .then((response) => {
            props.showToastMessage(`Email Saved !`, "success");
            setState({ ...state, isSubmitting: false, email: "" });
          })
          .catch((e) => {
            setState({ ...state, isSubmitting: false, email: "" });
            props.showToastMessage(`Something went wrong !`, "error");
          });
      }
    };

    return (
      <footer style={{ position: props.noAbsolute ? "relative" : "absolute" }}>
        <div className="container">
          <Row className="no-margin">
            <Col xs={12} md={12} lg={2} className="logo-wrapper no-padding-sm">
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  props.history.push("/");
                }}
                style={{ width: "50px", height: "45px" }}
              >
                <img src={logo} alt="Logo" style={{ width: "100%", height: "100%", backgroundColor: "white", borderRadius: "40px" }} />
              </a>
              <p>
                Farm Fit Digital LLC<br></br>&nbsp;© 2025<br></br>
                All Rights Reserved
              </p>
            </Col>
            <Col xs={4} md={4} lg={2} className="no-padding-sm">
              <div className="unstyled-lists">
                <h6>Site Map</h6>
                <ul>
                  <li>
                    <a
                      href="/recipes"
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/");
                      }}
                    >
                      Home
                    </a>
                  </li>
                  <li>
                    <a
                      href="/recipes"
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/recipes");
                      }}
                    >
                      Recipes
                    </a>
                  </li>
                  <li>
                    <a
                      href="/faqs"
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/faqs");
                      }}
                    >
                      FAQs
                    </a>
                  </li>
                  <li>
                    <a
                      href="/about"
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push("/about");
                      }}
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="/about"
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = "https://www.notion.so/Privacy-Policy-1fb77da24b2e80379bdec037f4508b64?invite=1fb77da24b2e805e84cd004cc930a840&r=0&state=eyJpbnZpdGVlRW1haWwiOiJhbWFuZGFAZmFybWZpdG1vbW1hLmNvbSIsImludml0ZXJOYW1lIjoicHJhc2FubmEgbWFoZW5kcmFuIn0%3D&pvs=0";
                      }}
                    >
                      Privacy Policy
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            {/* <Col xs={4} md={4} lg={2} className="no-padding-sm">
              <h6>Site Map</h6>
              <ul>
                <li aria-disabled={true}>
                  <a
                    href={"/app"}
                    onClick={(e) => {
                      e.preventDefault();
                      props.history.push("/app");
                    }}
                  >
                    iPhone App
                  </a>
                </li>
              </ul>
            </Col> */}
          </Row>
        </div>
        {/* <Helmet>
          <script type="text/javascript">
            {`window.$crisp=[];window.CRISP_WEBSITE_ID="06701846-8837-4a96-a40d-89dd1537ff6c";(function(){ d=document;s=d.createElement("script"); s.src="https://client.crisp.chat/l.js"; s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();`}
          </script>
        </Helmet> */}
      </footer>
    );
  }
};

const mapStateToProps = (state) => ({});

const dispatchActionToProps = (dispatch) => ({
  showToastMessage: bindActionCreators(showToastMessage, dispatch),
});

export default connect(
  mapStateToProps,
  dispatchActionToProps
)(toJS(withRouter(Footer)));
